/*/// <reference types="@types/googlemaps" />*/
/// <reference types="@types/google.maps" />

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomerInfo, LocationInfo, LocationOverview, RentalInfo, LockPosition, RentalObjectStatus, PageBase } from 't4core';
import { RentalDialog, ObjectDialog } from '../../../../t4common/';
import { BookingOverviewComponent } from '../../components/bookingOverview/bookingOverview';
import { FindBookingDialog } from '../../dialogs/findBookingDialog/findBookingDialog';
import * as moment from 'moment';
import { TireChangeDialog } from '../../dialogs/TireChangeDialog/TireChangeDialog';

declare var MarkerClusterer: any;

@Component({
    styleUrls: ['./map.css'],
    selector: 'map',
    templateUrl: './map.component.html',
})
export class MapComponent extends PageBase implements OnInit {

    constructor(el: ElementRef) {
        super(el, "OneWayAdmin");
    }

    // Map
    @ViewChild('gmap', {static: true}) gmapElement: any;
    @ViewChild('popupContent', {static: false}) popupElement: ElementRef;
    @ViewChild('txtMapSearch', {static: false}) gmapSearchBox: ElementRef;
    @ViewChild('locationOverview', {static: false}) overview: BookingOverviewComponent;

    private map: google.maps.Map;
    private markers = [];
    private customerPin: google.maps.marker.AdvancedMarkerElement;
    private searchPin: google.maps.marker.AdvancedMarkerElement;
    private infoWindow = new google.maps.InfoWindow();
    private searchBox: google.maps.places.Autocomplete;

    private lockMarkers = [];

    private geocoder = new google.maps.Geocoder();
    private directions = new google.maps.DirectionsService();
    private directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true, preserveViewport: true });

    // Data
    private overviewData: LocationOverview[] = [];


    // View data
    public objectTypes = [421, 422, 340, 423];
    public weeks = [];

    public selectedLocation: LocationInfo = new LocationInfo();
    public bookingQueue: RentalInfo[] = [];

    private _updatingCheckboxes: boolean = false;

    // Filters
    public txtMapSearch: FormControl = new FormControl(); 
    public chkOverview: FormControl = new FormControl(); 
    public chkLocks: FormControl = new FormControl(); 
    public selectedWeek: FormControl = new FormControl(201810); 
    public bookedTypes: FormControl = new FormControl(this.objectTypes); 
    public trailerTypes: FormControl = new FormControl(this.objectTypes);

    public chkShowShortages: FormControl = new FormControl(true);
    
    public chkShowAvailableTrailers: FormControl = new FormControl(true); 
    public chkShowConfirmableTrailers: FormControl = new FormControl(false); 
    public chkShowDisabledTrailers: FormControl = new FormControl(false);


  // PreliminaryRentals
  public selectedTab: number;
  public rawPreliminaryData: any[] = [];
  public filteredPreliminaryData: any[] = [];


    public get year(): string {
        if(!this.selectedWeek) return "";
        return this.selectedWeek.value.toString().substring(0, 4);
    }

    public get week(): string {
        if (!this.selectedWeek) return "";
        return this.selectedWeek.value.toString().substring(4);
    }

    async ngOnInit() {
      // Link checkboxes

      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

      const { } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

        this.chkShowAvailableTrailers.valueChanges.subscribe((x: boolean) => {
            if (this._updatingCheckboxes) return;
            this._updatingCheckboxes = true;

            if (x) {
                this.chkShowDisabledTrailers.setValue(false);
                this.chkShowConfirmableTrailers.setValue(false);
            }

            this._updatingCheckboxes = false;
        });

        this.chkShowConfirmableTrailers.valueChanges.subscribe((x: boolean) => {
            if (this._updatingCheckboxes) return;
            this._updatingCheckboxes = true;

            if (x) {
                this.chkShowAvailableTrailers.setValue(false);
                this.chkShowDisabledTrailers.setValue(false);
            }

            this._updatingCheckboxes = false;
        });

        this.chkShowShortages.valueChanges.subscribe((x: boolean) => {
            if (this._updatingCheckboxes) return;
            this._updatingCheckboxes = true;

            if (x) this.chkShowDisabledTrailers.setValue(false);

            this._updatingCheckboxes = false;
        });

        this.chkShowDisabledTrailers.valueChanges.subscribe((x: boolean) => {
            if (this._updatingCheckboxes) return;
            this._updatingCheckboxes = true;

            if (x) {
                this.chkShowAvailableTrailers.setValue(false);
                this.chkShowConfirmableTrailers.setValue(false);
            }

            this._updatingCheckboxes = false;
        });

        var mapProp = {
            center: new google.maps.LatLng(60.5793, 14.8143),
            zoom: 6,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapId: '2bfb441deccab4d5b8508848',
        };
        this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);


      const custPinImg = document.createElement('img');
      custPinImg.src = '/Images/Icons/CustomerPin.png';

      this.customerPin = new google.maps.marker.AdvancedMarkerElement();
      this.customerPin.content = custPinImg;
      this.customerPin.zIndex = 500000000;

        
     

        this.Api.get<number[]>('Util/GetWeeks', { n: 10 }).then(x => {
            this.weeks = x;
            this.selectedWeek.setValue(this.weeks[0]);
            this.updateFilter();

          this.searchBox = new google.maps.places.Autocomplete(this.gmapSearchBox.nativeElement, { types: ["(cities)"], componentRestrictions: { country: 'se' }, fields: ['geometry'] });
            this.searchBox.addListener("place_changed", () => {

                //get the place result
                let place: google.maps.places.PlaceResult = this.searchBox.getPlace();

                //verify result
                if (this.searchPin) this.searchPin.map = null;
                if (place.geometry === undefined || place.geometry === null) {
                    return;
                }

              // Add pin
              this.searchPin = new google.maps.marker.AdvancedMarkerElement({


                    map: this.map,
                    position: place.geometry.location,
                    /*animation: google.maps.Animation.DROP,*/
                    zIndex: 2000
                }); 

                //set latitude, longitude and zoom
                this.map.panTo(place.geometry.location);
                this.map.setZoom(10);
            });
        });
        // Load the Preliminary Rentals.
      const currentTime = new Date();
      const formattedTime = currentTime.toISOString().replace('T', ' ').slice(0, 19);
      this.rawPreliminaryData = await this.Api.get<any[]>("DataService/GetReport", { reportName: 'PreliminaryRentals', from: formattedTime, to: formattedTime });
      this.filteredPreliminaryData = this.rawPreliminaryData;
    }

    public async newBooking() {
        var dlg = await RentalDialog.newBooking(this.Dialog, {
                isOneWay: true,
                pickupLocationId: this.selectedLocation.Id,
                returnLocationId: null,
                typeId: 340,
                context: '43D09B7E-079A-4B29-83CB-ABBC928A7358'
            }, this.Settings);

            this.overview.refresh();
    }

    public findBooking() {
        var dlg = this.Dialog.open(FindBookingDialog, {});
   }

  public tireChangeDialog() {
    var dlg = this.Dialog.open(TireChangeDialog, { data: this.selectedLocation, autoFocus: false });
  }


    public updateFilter(noreload: boolean = false) {
        if (!noreload) {
            if (this.chkOverview.value) {
                this.loadOverview();
            } else {
                this.overviewData = [];
                this.loadLocations();
            }
            this.loadTrailerWhereabouts();
        } else {
            this.applyClientFilter();
        }
  }

    public prev() {
        var index = this.weeks.indexOf(this.selectedWeek.value);
        if (index - 1 < 0) return;

        this.selectedWeek.setValue(this.weeks[index - 1]);
    }

    public next() {
        var index = this.weeks.indexOf(this.selectedWeek.value);
        if (index + 1 >= this.weeks.length) return;

        this.selectedWeek.setValue(this.weeks[index + 1]);
  }

  private applyClientFilter() {

    for (var i of this.markers) {
      if (i.overview && i.location && !i.location.IsServiceLocation) {
        if (this.queryClientFilter(i.overview as LocationOverview)) {
          i.marker.map = this.map;
          this.setMarkerImage(i.marker, i.overview as LocationOverview);
          i.marker.zIndex = 2000 * Math.random() + 2000;
        } else {

          let imgElement = document.createElement('img');
          imgElement.src = '/Images/Icons/MapPin_' + (i.location.OpenForReturn ? 1 : 0) + "_" + (i.location.OpenForPickup ? 1 : 0) + '.png';
          i.marker.content = imgElement;
          i.marker.zIndex = (1000 * Math.random() + 1000);
        }
      }
      
    }
  }




    private setMarkerImage(marker: any, overview: LocationOverview) {
        var top = overview.UnboundBookingCount;
        var bottom = overview.AvailableObjectCount;
        var warning = overview.WarningActivated ? 1 : 0;
        var bottomRed = overview.AvailableObjectCount > overview.LocationInfo.SoftTrailerLimit ? 0 : 1;

        if (this.chkShowConfirmableTrailers.value == true) bottom = overview.ConfirmableObjectCount;
        if (this.chkShowDisabledTrailers.value == true) {
            bottom = overview.DisabledCount;
            warning = 0;
            bottomRed = bottom > 0 ? 0 : 1;
        }

      /*marker.setIcon(`https://thuleturbo.blob.core.windows.net/cdn/Pins/Pin_${Math.min(20, top)}_${Math.min(60, bottom)}_${bottomRed}_${warning}.png`);*/

      const imgEle = document.createElement('img');
      imgEle.src = `https://thuleturbo.blob.core.windows.net/cdn/Pins/Pin_${Math.min(20, top)}_${Math.min(60, bottom)}_${bottomRed}_${warning}.png`;
      //imgEle.style.width = '40px'; 
      //imgEle.style.height = '40px'; 
      marker.zIndex = (1000 * Math.random() + 1000);
      marker.content = imgEle;
    }

    private queryClientFilter(overview: LocationOverview): boolean {
        if (!overview) return true;

        return ((this.chkShowShortages.value && overview.UnboundBookingCount > 0) || (this.chkShowAvailableTrailers.value && overview.AvailableObjectCount > 0) || (this.chkShowConfirmableTrailers.value && overview.ConfirmableObjectCount > 0) || (this.chkShowDisabledTrailers.value && overview.DisabledCount > 0));
    }

    private loadOverview() {
        var bTypes = 0;
        var oTypes = 0;

        for (var i of this.bookedTypes.value) {
            if (i == 421) bTypes += 1;
            else if (i == 422) bTypes += 2;
            else if (i == 340) bTypes += 4;
            else if (i == 423) bTypes += 8;
        }
        for (var i of this.trailerTypes.value) {
            if (i == 421) oTypes += 1;
            else if (i == 422) oTypes += 2;
            else if (i == 340) oTypes += 4;
            else if (i == 423) oTypes += 8;
        }

        if (bTypes == 15) bTypes = 0; // All
        if (oTypes == 15) oTypes = 0; // All

        var token = this.UI.beginLoading("Turbo.OneWay.Map.msgLoadingBookingData", "Loading booking data", null);
        this.Api.get<LocationOverview[]>("OneWay/GetOverview", { weekId: this.selectedWeek.value, bookingTypes: bTypes, objectTypes: oTypes }).then(x => {
            this.overviewData = x;
            this.UI.loaderCompleted(token);
            this.loadLocations();
        });
    }

    private async loadTrailerWhereabouts() {
        var locks = await this.Api.get<LockPosition[]>("OneWay/GetTrailerWhereabouts", {});

        for (var item2 of this.lockMarkers) item2.map = null;
        this.lockMarkers = [];

        if (this.chkLocks.value) {
            for (var item of locks) {
                this.addLockMarker(item);
            }
        }
    }

  private addLockMarker(item: LockPosition) {


    let imgLock = document.createElement('img');
    imgLock.src = 'https://thuleturbo.blob.core.windows.net/cdn/Pins/ActiveLock.png';
    imgLock.style.opacity = "1"; 

    const marker = new google.maps.marker.AdvancedMarkerElement({
      map: this.map,
      position: new google.maps.LatLng(item.Lat, item.Lng),
      content: imgLock,
      title: item.Object.Alias + ", " + item.LastUpdate.format("YYYY-MM-DD HH:mm"),
      zIndex: 1000 * Math.random() + 8000
    });

   
    if (!item.AtStation && item.Object.Status != RentalObjectStatus.Disclosed && item.Object.Status != RentalObjectStatus.Late) {
      imgLock.src = 'https://thuleturbo.blob.core.windows.net/cdn/Pins/AlertedLock.png';
      marker.zIndex += 2000;
    }
    else if (item.Object.Status == RentalObjectStatus.Disclosed || item.Object.Status == RentalObjectStatus.Late) {
      imgLock.src = 'https://thuleturbo.blob.core.windows.net/cdn/Pins/LockInUse.png';
      marker.zIndex += 1000;
    }
    else if (item.LastUpdate < this.yesterday) {
      imgLock.src = 'https://thuleturbo.blob.core.windows.net/cdn/Pins/InactiveLock.png';
      imgLock.style.opacity = "0.75"; 
      marker.zIndex -= 1000;
    }
        marker.addListener('click', () => {  
            ObjectDialog.open(this.Dialog, null, item.ObjectId);
        });

        this.lockMarkers.push(marker);
    }

    private loadLocations() {
        var token = this.UI.beginLoading("Turbo.OneWay.Map.msgLoadingLocationData", "Loading location data", null);
        this.Api.get<LocationInfo[]>("OneWay/LoadLocations").then(x => {
            var data = x;
            var markers = [];

            var i = 0;
            for (var item of x) {
                var ovData = this.overviewData.find(x => x.LocationId == item.Id);
                

                // Add region for service locations
                if (item.IsServiceLocation) {
                    var areaCoords = [];
                    for (var l of data.filter(y => y.ServiceLocationId == item.Id && y.ServiceZone < 3)) {
                        areaCoords.push(new google.maps.LatLng(l.Latitude, l.Longitude));
                    }

                    if (areaCoords.length > 0) this.addLocation(item, ovData, 0);

                    areaCoords.sort((a, b) => { return a.lng() - b.lng(); });
                    areaCoords.sort((a, b) => { return a.lat() - b.lat(); });

                    var hullCoords = [];
                    this.chainHull_2D(areaCoords, areaCoords.length, hullCoords);

                    // Construct the polygon.
                    var polygon = new google.maps.Polygon({
                        paths: hullCoords,
                        strokeColor: '#000000',
                        strokeOpacity: 0.2,
                        strokeWeight: 2,
                        fillColor: '#000000',
                        fillOpacity: 0.1,
                        map: this.map,
                        zIndex: 0
                    });
                    this.markers.push({ locationId: item.Id, marker: polygon });
                } else {
                    this.addLocation(item, ovData, 50);
                }

                i++;
            }

            //this.addHeatmap(x);
            //var markerCluster = new MarkerClusterer(this.map, markers, { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });

            this.UI.loaderCompleted(token);
        });
  }

  private addLocation(item: LocationInfo, overview: LocationOverview, delay: number) {
    var existing = this.markers.filter(x => x.locationId == item.Id);
    for (var i = 0; i < existing.length; i++) {
      existing[i].marker.map = null; 
      this.markers.splice(this.markers.indexOf(existing[i]), 1);
    }

    setTimeout(() => {

      let imgEle = document.createElement('img');
      imgEle.src = '/Images/Icons/MapPin_' + (item.OpenForReturn ? 1 : 0) + "_" + (item.OpenForPickup ? 1 : 0) + '.png';

      var marker: any = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: new google.maps.LatLng(item.Latitude, item.Longitude),
        content: imgEle,
        title: item.Name + ", " + item.Address,
        //animation: google.maps.Animation.DROP,
        zIndex: 2000 * Math.random() + 2000
      });

      if (this.chkLocks.value) {
        marker.style.opacity = "0.2";

      }

      if (item.IsServiceLocation) {
        let imgServiceEle = new google.maps.marker.PinElement({
          glyph: 'S',
          glyphColor: 'black'
        });
        marker.content = imgServiceEle.element;
        /*marker.zIndex = 1;*/
        marker.zIndex = -100;

      } else if (overview) {
        this.setMarkerImage(marker, overview);
      }

      marker.addListener('click', () => {
        this.infoWindow.setContent(`<h5>${item.Name}</h5><span>${item.Address}<br/>${item.ZipCode} ${item.City}<br/><br/>${item.Phone}<br/>${item.Email}<br/><br/>${item.OpenHours}<br /><br />${item.SoftTrailerLimit}/${item.HardTrailerLimit}</span>`);
        this.infoWindow.open(this.map, marker);
        this.selectedLocation = item;
        this.updatePreliminaryFilter(item);
      });

      this.markers.push({ locationId: item.Id, location: item, overview: overview, marker: marker });

      if (!item.IsServiceLocation && !this.queryClientFilter(overview)) {
        imgEle.src = '/Images/Icons/MapPin_' + (item.OpenForReturn ? 1 : 0) + "_" + (item.OpenForPickup ? 1 : 0) + '.png';
        marker.zIndex = 1000 * Math.random() + 1000;
      }

      return marker
    }, delay);
  }

  

      

    public customerActivated(customer: CustomerInfo) {
        if (customer) {
            this.geocoder.geocode({
                address: `${customer.Address} ${customer.ZipCode} ${customer.City}`
            }, x => {
              if (x.length > 0) {
                this.customerPin.position = x[0].geometry.location;
                    this.customerPin.map = this.map;
                }
            });
        } else {
            this.customerPin.map = null;
        }
    }

    public bookingActivated(booking: RentalInfo) {
        if (booking) {
            this.directions.route({
                origin: new google.maps.LatLng(booking.PickupLocation.Latitude, booking.PickupLocation.Longitude),
                destination: new google.maps.LatLng(booking.ReturnLocation.Latitude, booking.ReturnLocation.Longitude),
                travelMode: google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false
            }, (routes, status) => {
                if (status == google.maps.DirectionsStatus.OK) {
                    this.directionsRenderer.setDirections(routes);
                    this.directionsRenderer.setMap(this.map);
                }
            });
        } else {
            this.directionsRenderer.setMap(null);
        }
    }

    // Map functions
    private addHeatmap(data: LocationInfo[]) {
        var heatmapData = [];

        for (var i of data) {
            heatmapData.push({ location: new google.maps.LatLng(i.Latitude, i.Longitude), weight: Math.round(Math.random() * 1000 + 100) });
        }
        var heatmap = new google.maps.visualization.HeatmapLayer({
            data: heatmapData,
            dissipating: false,
            radius: 5
        });

        heatmap.setMap(this.map);
    }

    private chainHull_2D(P, n, H) {
    // the output array H[] will be used as the stack
    var bot = 0,
        top = (-1); // indices for bottom and top of the stack
    var i; // array scan index
    // Get the indices of points with min x-coord and min|max y-coord
    var minmin = 0,
        minmax;

    var xmin = P[0].lng();
    for (i = 1; i < n; i++) {
        if (P[i].lng() != xmin) {
            break;
        }
    }

    minmax = i - 1;
    if (minmax == n - 1) { // degenerate case: all x-coords == xmin 
        H[++top] = P[minmin];
        if (P[minmax].lat() != P[minmin].lat()) // a nontrivial segment
            H[++top] = P[minmax];
        H[++top] = P[minmin]; // add polygon endpoint
        return top + 1;
    }

    // Get the indices of points with max x-coord and min|max y-coord
    var maxmin, maxmax = n - 1;
    var xmax = P[n - 1].lng();
    for (i = n - 2; i >= 0; i--) {
        if (P[i].lng() != xmax) {
            break;
        }
    }
    maxmin = i + 1;

    // Compute the lower hull on the stack H
    H[++top] = P[minmin]; // push minmin point onto stack
    i = minmax;
    while (++i <= maxmin) {
        // the lower line joins P[minmin] with P[maxmin]
        if (this.isLeft(P[minmin], P[maxmin], P[i]) >= 0 && i < maxmin) {
            continue; // ignore P[i] above or on the lower line
        }

        while (top > 0) { // there are at least 2 points on the stack
            // test if P[i] is left of the line at the stack top
            if (this.isLeft(H[top - 1], H[top], P[i]) > 0) {
                break; // P[i] is a new hull vertex
            }
            else {
                top--; // pop top point off stack
            }
        }

        H[++top] = P[i]; // push P[i] onto stack
    }

    // Next, compute the upper hull on the stack H above the bottom hull
    if (maxmax != maxmin) { // if distinct xmax points
        H[++top] = P[maxmax]; // push maxmax point onto stack
    }

    bot = top; // the bottom point of the upper hull stack
    i = maxmin;
    while (--i >= minmax) {
        // the upper line joins P[maxmax] with P[minmax]
        if (this.isLeft(P[maxmax], P[minmax], P[i]) >= 0 && i > minmax) {
            continue; // ignore P[i] below or on the upper line
        }

        while (top > bot) { // at least 2 points on the upper stack
            // test if P[i] is left of the line at the stack top
            if (this.isLeft(H[top - 1], H[top], P[i]) > 0) {
                break;  // P[i] is a new hull vertex
            }
            else {
                top--; // pop top point off stack
            }
        }

        // breaks algorithm        
        //        if (P[i].lng() == H[0].lng() && P[i].lat() == H[0].lat()) {
        //            return top + 1; // special case (mgomes)
        //        }

        H[++top] = P[i]; // push P[i] onto stack
    }

    if (minmax != minmin) {
        H[++top] = P[minmin]; // push joining endpoint onto stack
    }

    return top + 1;
    }

    private isLeft(P0, P1, P2):number {    
        return (P1.lng() - P0.lng()) * (P2.lat() - P0.lat()) - (P2.lng() - P0.lng()) * (P1.lat() - P0.lat());
    }
  // End Map functions


  private updatePreliminaryFilter(location: LocationInfo) {
    if (this.rawPreliminaryData.length > 0)
    this.filteredPreliminaryData = this.rawPreliminaryData.filter(x => x.LocationId === location.Id);
  }
}
